import PatientObjectBaseProvider from "./patientObjectBaseProvider";

export default class NexusVideoProvider extends PatientObjectBaseProvider {
	constructor($http, patientProvider, storage, eventBus) {
		super("videoStatus", $http, patientProvider, storage, eventBus);
	}
}
